export default __webpack_public_path__ + "static/media/DSTitleMediumBold.751abff6.otf";